import { render } from "./index.vue?vue&type=template&id=3aec8040&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3aec8040&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aec8040"]])

export default __exports__